
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M11 13.487V3.5a.5.5 0 01.5-.499h1a.5.5 0 01.5.5v9.987a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5zm7-5.763a.535.535 0 00-.36-.17.512.512 0 00-.37.15l-.71.71a.509.509 0 000 .679A5.907 5.907 0 0118 12.988c0 3.31-2.686 5.993-6 5.993s-6-2.683-6-5.993a5.908 5.908 0 011.45-3.895.51.51 0 000-.68l-.71-.709a.512.512 0 00-.37-.15.537.537 0 00-.37.17 7.984 7.984 0 00.463 11.052 8.005 8.005 0 0011.074 0A7.983 7.983 0 0018 7.724z"}})])
          )
        }
      }
    